<template>
  <aside v-show="isAsideVisible" class="aside is-placed-left is-expanded">
    <div class="image">
      <router-link to="/">
        <img v-if="user" src="../../public/mig_profile.jpg" class="profile-pic" />
      </router-link>

      <!-- <figure class="media-left">
            <div class="image-cropper">
              <img :src="user.photoUrl" alt="avatar" class="profile-pic" />
            </div>
      </figure> -->
    </div>
    <div class="menu is-menu-main">
      <aside-menu-list @menu-click="menuClick" :menu="menu" />
    </div>
  </aside>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AsideMenu',
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState(['isAsideVisible']),

    user() {
      return this.$store.getters['auth/authUser'];
    },
  },
  methods: {
    menuClick(item) {
      //
    },
  },
};
</script>


<style scoped>
.image {
  position: relative;
  overflow: hidden;
  /* border-radius: 50%; */
}

.profile-pic {
  margin: 0 auto;
  object-fit: fill;
  width: 100%;
  height: 30px;
}
</style>
